import { createFileRoute } from '@tanstack/react-router'
import DetailCriteriaTemplate from '@/components/smartqc-route/criteria/detail-criteria-template.jsx'
import { navigateGuard } from '@/utils/auth.js'
import { UserRole } from '@/constants/user.js'

export const Route = createFileRoute('/_auth/smart-qc/criteria/$templateType')({
  beforeLoad: ({ location }) => {
    return navigateGuard(location, [UserRole.ADMINISTRATOR])
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { templateType } = Route.useParams()
  return <DetailCriteriaTemplate type={templateType} />
}
